import Axios from 'axios'
import { USER_SET } from '../mutation-types'

// initial state
const state = {
  id: '',
  emailAddress: '',
  errorMessage: '',
  errorCode: '',
  purchasableUpgrades: [],
  purchaseableSubsProducts: null,
  globalContactMe: false,
  fetchingUser: false
}

const actions = {
  fetch ({ commit }) {
    commit('setFetchingUserState', true)
    Axios.get('/user/info')
    .then((response) => {
      commit(USER_SET, response.data)
    })
    .catch((error) => {
      commit('errorMessage', error.response.data)
    })
    .finally(() => {
      commit('setFetchingUserState', false)
    })
  }
}

const mutations = {
  [USER_SET] (state, newState) {
    Object.keys(state).forEach((key) => {
      state[key] = newState[key] ? newState[key] : ''
    })
  },

  setFetchingUserState (state, newState) {
    state.fetchingUser = newState
  },

  errorMessage (state, newState) {
    state.errorMessage = newState.error
    state.errorCode = newState.code
    state.info = ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./vue/checkout/store/modules/user.js